import utils from '@/utils/utils';
export default   {
	0:{
		text:'未指派',
		color:'rgba(248, 18, 18, 1)',
		color16:utils.rgbaTo16('rgba(248, 18, 18, 1)').color,
	},
	1:{
		text:'处理中',
		color:'rgba(230, 162, 60,1)',
		color16:utils.rgbaTo16('rgba(230, 162, 60,1)').color,
	},
	2:{
		text:'处理完成',
		color:'rgba(0, 0, 255, 1)',
		color16:utils.rgbaTo16('rgba(0, 0, 255, 1)').color,
	},
	3:{
		text:'确认通过',
		color:'rgba(103, 194, 58,1)',
		color16:utils.rgbaTo16('rgba(103, 194, 58,1)').color,
	}
}

